export enum DayTableColumns {
  Date = 'datum',
  K = 'correctionIndicator',
  Time = 'uzzm',
  Hours = 'zzm',
  Konto = 'absenceCode',
  Absence = 'absenceName',
  OrderNr = 'orderNr',
  OrderName = 'orderName',
  costCenterNumber = 'costCenterNumber',
  CostCenterName = 'costCenterName',
  KSatz = 'cost',
  Operation = 'operation',
  FullDate = 'FullDate',
  FullWorkTimeEntry = 'FullWorkTimeEntry',
  FullAbsenceTimeEntry = 'FullAbsenceTimeEntry',
}
